<template>
  <v-dialog
    width="700"
    persistent
    transition="slide-x-transition"
    v-model="get_modal_view_relatorio"
  >
    <v-card class="expande-horizontal wrap">
      <div class="expande-horizontal px-1 pr-3 py-3">
        <v-btn dark @click="fecha_modal_view_relatorio" icon>
          <v-icon color="grey">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span style="font-size: 17pt; width: 100%;" class="fonte">
          Registro de relatorio
        </span>
        <div class="expande-horizontal"></div>
        <v-btn class="elevation-3" icon @click="fecha_modal_view_relatorio">
          <v-icon color="red">
            mdi-close
          </v-icon>
        </v-btn>
      </div>

      <div class="expande-horizontal wrap py-6 pt-0 pb-0">
        <v-flex class="pa-3" xs12>
          <div class="expande-horizontal column">
            <modal-send-archive />
            <v-form ref="form" class="expande-horizontal wrap">
              <v-flex xs12>
                <span class="fonte"> Categoria </span>
                <v-select
                  solo-inverted
                  dense
                  flat
                  :items="get_relatoriocategorias.docs"
                  item-text="nome"
                  return-object
                  v-model="get_relatorio.categoria"
                  :color="$theme.primary"
                  :rules="[v => !!v || 'Preencha este campo']"
                  append-icon="mdi-plus"
                  @click:append="abre_modal_view_categoria_relatorio"
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <span class="fonte"> Nome </span>
                <v-text-field
                  solo-inverted
                  dense
                  flat
                  v-model="get_relatorio.nome"
                  :color="$theme.primary"
                  :rules="[v => !!v || 'Preencha este campo']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <span class="fonte"> Descrição </span>
                <v-text-field
                  solo-inverted
                  dense
                  flat
                  v-model="get_relatorio.descricao"
                  :color="$theme.primary"
                  :rules="[v => !!v || 'Preencha este campo']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <span class="fonte"> Preço </span>
                <v-text-field
                  solo-inverted
                  dense
                  flat
                  v-model="get_relatorio.preco"
                  prefix="R$"
                  :color="$theme.primary"
                  :rules="[v => !!v || 'Preencha este campo']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4 class="px-1">
                <span class="fonte"> Desconto </span>
                <v-text-field
                  solo-inverted
                  dense
                  flat
                  v-model="get_relatorio.desconto"
                  prefix="R$"
                  :color="$theme.primary"
                  :rules="[v => !!v || 'Preencha este campo']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <span class="fonte"> Preço Final </span>
                <v-text-field
                  solo-inverted
                  dense
                  flat
                  v-model="get_relatorio.preco_final"
                  prefix="R$"
                  :color="$theme.primary"
                ></v-text-field>
              </v-flex>
            </v-form>
          </div>
        </v-flex>
      </div>

      <div class="expande-horizontal">
        <v-btn large dark @click="valida_form" tile block color="green">
          <span class="fonte"> Salvar </span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalSendArchive from "../../shared/components/ModalSendArchive.vue";
export default {
  components: { ModalSendArchive },
  computed: {
    ...mapGetters([
      "get_relatorio",
      "get_modal_view_relatorio",
      "get_relatoriocategorias",
      "getLoggedUser"
    ])
  },
  methods: {
    ...mapActions([
      "criar_relatorio",
      "atualizar_relatorio",
      "fecha_modal_view_relatorio",
      "listar_categorias_relatorios",
      "abre_modal_view_categoria_relatorio"
    ]),
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_relatorio._id
          ? this.atualizar_relatorio()
          : this.criar_relatorio();
      }
    }
  },
  created() {
    this.listar_categorias_relatorios();
  }
};
</script>
